import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

export const useNavigationItem = (route: string) => {
  const [isActive, setIsActive] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    setIsActive(window.location.pathname === route);
  }, [window.location.pathname, route]);

  const navigateTo = (route: string) => {
    navigate(route);
  };

  return { isActive, setIsActive, navigateTo };
};
